/**
 * Every state a consumer branches on is explicit. A nullable field never
 * doubles as a status signal — services return a discriminator alongside it.
 */
export interface ServiceError {
  statusCode: number;
  code: string;
  message: string;
  details?: Record<string, unknown>;
}

export interface ErrorResponse {
  error: true;
  statusCode: number;
  code: string;
  message: string;
  path?: string;
  timestamp: string;
  requestId?: string;
  details?: Record<string, unknown>;
}

export const ERROR_CODES = {
  validationFailed: 'VALIDATION_FAILED',
  unauthenticated: 'UNAUTHENTICATED',
  invalidCredentials: 'INVALID_CREDENTIALS',
  tokenExpired: 'TOKEN_EXPIRED',
  tokenRevoked: 'TOKEN_REVOKED',
  /** Refresh found the person's account no longer active; the session is revoked. */
  accountDisabled: 'ACCOUNT_DISABLED',
  /** The double-submit CSRF check refused a cookie-authenticated write. */
  csrfMismatch: 'CSRF_MISMATCH',
  forbidden: 'FORBIDDEN',
  notFound: 'NOT_FOUND',
  conflict: 'CONFLICT',
  dependencyUnavailable: 'DEPENDENCY_UNAVAILABLE',
  internal: 'INTERNAL_ERROR',
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];
